<div class="flex flex-col min-h-screen" style="background-image: linear-gradient(to right, #BBE9FF, #FFC7ED);">
  <div class="flex-1 flex items-center justify-center py-6 px-4 sm:px-6 lg:px-8">
    <div class="max-w-4xl w-full flex flex-col md:flex-row bg-white shadow-lg rounded-lg overflow-hidden transition-all duration-300 ease-in-out">

      <!-- Left Side Image (Logo removed from here) -->
      <div class="hidden md:block w-full md:w-1/2 bg-gradient-to-br from-purple-100 to-purple-200 p-8">
        <img src="assets/images/register-org/login-auth.svg" alt="Login Illustration" class="w-full h-full object-contain">
      </div>

      <!-- Right Side Form -->
      <div class="w-full md:w-1/2 flex flex-col justify-center p-6 sm:p-8 bg-white">

        <!-- Enlarged Logo Above Welcome Text -->
        <div class="flex justify-center mb-6">
          <img src="https://arniuniversity.edu.in/assets/img/logo/arni-updated-logo.png" alt="ARNI University Logo" style="width: 200px">
        </div>

        <!-- Welcome Text -->
        <div class="text-center mb-6">
          <h2 class="text-3xl font-bold text-gray-800 mb-1" *ngIf="formType === 'login'" style="font-family: var(--vex-font)">
            ARNI University
          </h2>
          <h2 class="text-3xl font-bold text-gray-800 mb-1" *ngIf="formType === 'signIn'" style="font-family: var(--vex-font)">
            Join Us!
          </h2>
          <p class="text-gray-600 text-md" style="font-family: var(--vex-font)">
            Scholarship Exam
          </p>
        </div>

        <!-- Login Form -->
        <form [formGroup]="loginForm" class="space-y-6" *ngIf="formType === 'login'">

          <!-- Contact Field -->
          <mat-form-field appearance="outline" class="w-full">
            <mat-label>Contact</mat-label>
            <input matInput placeholder="Enter Your Contact" formControlName="contact" required type="number">
            <small class="text-red-500" *ngIf="submitted && loginForm.get('contact').hasError('required')">
              Contact is required
            </small>
            <small class="text-red-500" *ngIf="submitted && loginForm.get('contact')?.errors?.minlength">
              Contact must be at least {{ loginForm.get('contact')?.errors?.minlength?.requiredLength }} characters long
            </small>
          </mat-form-field>

          <!-- DOB Field -->
          <mat-form-field appearance="outline" class="w-full">
            <mat-label>Date of Birth</mat-label>
            <input type="text" formControlName="dob" matInput placeholder="YYYY-MM-DD" required>
            <small class="text-red-500" *ngIf="submitted && loginForm.get('dob').hasError('required')">
              Date of Birth is required
            </small>
            <small class="text-red-500" *ngIf="submitted && loginForm.get('dob')?.errors?.minlength">
              Date of Birth must be at least {{ loginForm.get('dob')?.errors?.minlength?.requiredLength }} characters long
            </small>
          </mat-form-field>
          <span class="text-warn-500" style="margin-top: -25px; margin-left: 10px">
            Enter Date of Birth in YYYY-MM-DD format only
          </span>

          <!-- Remember Me -->
          <div class="flex items-center justify-between">
            <mat-checkbox color="primary">Remember Me</mat-checkbox>
          </div>

          <!-- Login Button -->
          <button (click)="login()" mat-raised-button color="primary" class="w-full py-2 bg-blue-600 hover:bg-blue-700 text-white rounded-lg transition">
            Log In
          </button>

          <!-- Register Link -->
          <p class="text-center text-gray-600 text-sm">
            Don't have an account?<br />
            <a class="text-blue-500 cursor-pointer hover:underline" (click)="goTo('auth/register')">
              Register
            </a>
          </p>
        </form>
      </div>
    </div>
  </div>
</div>
